import ContractPage from './contractPage.component';

export default ContractPage;